import cn from 'classnames'
import React from 'react'
import config from '../../config.json'
import { Modal, ModalBody, ModalContent } from '@nextui-org/react'

const FullImageView = ({ image, video, toggleFunc }) => {
    if (video) {
        return (
            <Modal
                isDismissable={true}
                size={'full'}
                isOpen={video}
                classNames={{
                    wrapper: 'z-[1302]',
                    body: 'absolute w-screen h-screen m-auto top-0 left-0 backdrop-filter backdrop-blur-xl',
                    closeButton:
                        'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
                }}
                onClose={toggleFunc}
            >
                <ModalContent>
                    {(onClose) => (
                        <ModalBody
                            className={cn(
                                'absolute w-screen h-screen m-auto top-0 left-0 backdrop-filter backdrop-blur-xl',
                            )}
                        >
                            <div
                                className={cn(
                                    'absolute w-screen h-screen m-auto top-0 left-0 backdrop-filter backdrop-blur-xl',
                                )}
                                onClick={() => toggleFunc()}
                            >
                                <div className={'flex w-full h-full m-auto'}>
                                    <video
                                        loop
                                        controls
                                        autoPlay={true}
                                        muted={true}
                                        className={cn('m-auto w-auto h-auto')}
                                    >
                                        <source
                                            src={
                                                video.includes('http')
                                                    ? video
                                                    : config.ipfs + video
                                            }
                                        />
                                        Your browser does not support the video
                                        tag.
                                    </video>
                                </div>
                            </div>
                        </ModalBody>
                    )}
                </ModalContent>
            </Modal>
        )
    } else if (image) {
        return (
            <Modal
                isDismissable={true}
                size={'full'}
                isOpen={image}
                classNames={{
                    wrapper: 'z-[1302]',
                    body: 'absolute w-screen h-screen m-auto top-0 left-0 backdrop-filter backdrop-blur-xl',
                    closeButton:
                        'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
                }}
                onClose={toggleFunc}
            >
                <ModalContent>
                    {(onClose) => (
                        <ModalBody
                            className={cn(
                                'absolute w-screen h-screen m-auto top-0 left-0 backdrop-filter backdrop-blur-xl',
                            )}
                        >
                            <div
                                className={cn(
                                    'absolute w-screen h-screen m-auto top-0 left-0 backdrop-filter backdrop-blur-xl',
                                )}
                                onClick={() => toggleFunc()}
                            >
                                <div className={'flex w-full h-full m-auto'}>
                                    <img
                                        className={
                                            'max-h-full max-w-full m-auto'
                                        }
                                        src={
                                            image.includes('http')
                                                ? image
                                                : config.ipfs + image
                                        }
                                    />
                                </div>
                            </div>
                        </ModalBody>
                    )}
                </ModalContent>
            </Modal>
        )
    }
}

export default FullImageView
